import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LoadingService {
  // true = le spinner est actif, false = il est fini
  public isLoading$ = new BehaviorSubject<boolean>(true);

  finishLoading() {
    this.isLoading$.next(false);
  }
}